import { formatNumber } from '@shared/utils';

import type { METRIC_COLUMNS } from './columns';
import type { QuestionnaireMetric } from './types';

export function formatRate(value: number): string {
  return `${value.toFixed(2)}%`;
}

export function formatMetricValue(
  key: (typeof METRIC_COLUMNS)[number]['key'],
  metric: QuestionnaireMetric,
) {
  if (key === 'passingRate') return formatRate(metric.passingRate);
  return formatNumber(metric[key]);
}
